import { render } from "./TenantReview.vue?vue&type=template&id=f8c38524&ts=true"
import script from "./TenantReview.vue?vue&type=script&lang=ts"
export * from "./TenantReview.vue?vue&type=script&lang=ts"

import "./TenantReview.vue?vue&type=style&index=0&id=f8c38524&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__